import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { withRouter } from 'react-router-dom';
import CommToolContext from '../../common/comm_tool_context';
import ProjectTeam from '../Project_Team';
import ReviewPage from '../project_overview';
import { getProject, getTeamRoleMembers } from '../../../api';
import ProjectTabRoutes from '../../../components/ProjectTabsList/ProjectTabRoutes';
import Asset from '../Asset/Asset';
import ProjectDetailsWrapper from "../projectdetails_wrapper";
import MeetingNotes from '../../../containers/startproj/MeetingNotes';
import JobJournal from '../../../containers/startproj/JobJournal';

const { TabPane } = Tabs;
function InDevTabs(props) {
    const { project, context, history, match, status, hazardousMaterialsSelected } = props;
    const [teamMembers, setTeamMembers] = useState([]);
    const [currentProject, setCurrentProject] = useState(project);
    const [shouldRefreshMeetingNotes, setShouldRefreshMeetingNotes] = useState(false);
    const [shouldRefreshJobJournals, setShouldRefreshJobJournals] = useState(false);

    const { setActiveProject } = context;

    useEffect(() => {
        setActiveProject(project);
    }, [])


    async function developTabsOnclick(key) {
        const { project } = props;
        switch (key) {
            case 'overview':
                const updatedProject = await getProject(project.id);
                setCurrentProject(updatedProject);
                setActiveProject(updatedProject);
                const teamMembers = await getTeamRoleMembers(project.id);
                setTeamMembers(teamMembers);
                break;
            case 'details':
                const updatedProjectList = await getProject(project.id);
                setCurrentProject(updatedProjectList);
                setActiveProject(updatedProjectList);
                break;
            case 'notes':
                setShouldRefreshMeetingNotes(true);
                break;
            case 'journal':
                setShouldRefreshJobJournals(true);
                break;
            default:
                return null;
                break;
        }
    }


    return (
        <CommToolContext.Consumer>
            {context => (
                <div className="container-fluid">
                    <ProjectTabRoutes project={project} context={context} status={status} />
                    <h4>
                        <b>{project.stationName}</b>
                    </h4>
                    <Tabs
                        defaultActiveKey='details'
                        className='nav-B'
                        onChange={developTabsOnclick}
                        onTabClick={(key) => history.push({
                            pathname: `/${status}/${project.id}/${key}`
                        })}
                        type='card'
                        activeKey={match.params.tabId || 'details'}
                    >
                        <TabPane tab="Project Details" key="details">
                            <ProjectDetailsWrapper project={currentProject} setCurrentProject={setCurrentProject} hazardousMaterialsSelected={hazardousMaterialsSelected}/>
                        </TabPane>
                        <TabPane tab="Asset Summary" key="assetsummary">
                            <Asset project={project} />
                        </TabPane>
                        <TabPane tab="Team" key="team">
                            <ProjectTeam project={project} context={context} status={status} />
                        </TabPane>
                        <TabPane tab="Project Overview" key="overview">
                            <ReviewPage project={currentProject} context={context} teamMembers={teamMembers} status={status}/>
                        </TabPane>
                        <TabPane tab='Meeting Notes' key="notes">
                            <MeetingNotes project={currentProject} status={status} history={history}
                                refreshNotes={shouldRefreshMeetingNotes} setRefreshNotes={setShouldRefreshMeetingNotes} />
                        </TabPane>
                        <TabPane tab='Job Journal' key="journal">
                            <JobJournal project={currentProject} status={status} context={context}
                                refreshJobJournals={shouldRefreshJobJournals} setRefreshJobJournals={setShouldRefreshJobJournals} />
                        </TabPane>
                    </Tabs>
                </div>
            )}
        </CommToolContext.Consumer>
    );

}

InDevTabs.contextType = InDevTabs;
export default withRouter(InDevTabs);
